function initialState() {
  return {
    people: [],
    loading: false,
  };
}

let state = initialState();

export { initialState, state };
